<template>
	<t-input-wrapper
		:label="label"
		:description="description"
		:hint="hint"
		:isInvalid="isInvalid"
		:validationMessage="validationMessage"
		:warningMessage="warningMessage"
		:isRequired="isRequired"
	>
		<input
			ref="input"
			:style="getStyle"
			:value="value"
			:class="[{invalid: isInvalid, disabled: disabled}, inputCssClass, size]"
			:placeholder="placeholder"
			:disabled="disabled"
			:tabindex="tabindex"
			autocomplete="autocomplete_off_hack"
			v-bind="$attrs"
			class="input"
			v-on="inputListeners"
		>
	</t-input-wrapper>
</template>

<script>

/**
 * In the code above one would propose to use v-bind="$attrs", which allows us to pass down props which are not set to the input element.
 * The element will then be like the normal input element in the dom, but powered by a wrapper here.
 * We could replace disabled, placeholder, style and so on in the component. Making the code much much cleaner.
 *
 */
import formMixin from './formMixin';
import inputWrapperMixin from './inputWrapperMixin';
import TInputWrapper from './TInputWrapper';
export default {
	name: 'TTextInput',
	components: { TInputWrapper },
	mixins: [ formMixin, inputWrapperMixin ],
	inheritAttrs: false,
	props: {
		inputCssClass: String,
		tabindex: [Number, String],
	},
	methods: {
		focus() {
			this.$refs.input.focus();
		},
		blur() {
			this.$refs.input.blur();
		},
	}
};
</script>

<style lang="scss" scoped>
@import './scss/form';
</style>

<style lang="scss">
@import './scss/grid-input';
</style>


<docs>
## Examples

### Simple Text input

```jsx
<div style="display: inline-grid; grid-row-gap: 10px; grid-template-rows: repeat(3, auto); width: 100%;">
	<t-text-input width="280px" placeholder="Text input placeholder..."/>
	<t-text-input width="280px" value="Disabled" disabled />
	<t-text-input width="280px" value="Text input invalid" isInvalid />
</div>
```

### Label and description

```jsx
<t-text-input
	width="280px"
	label="Label"
	description="This is a description."
	placeholder="Placeholder text"
/>
```

### Hint

```jsx
<t-text-input
	width="280px"
	label="Label"
	hint="This is a hint"
	placeholder="Placeholder text..."
/>
```

### Validation message

```jsx
<t-text-input
	width="280px"
	label="Label"
	placeholder="Placeholder text..."
	validationMessage="This is a validation message"
	isInvalid
/>
```
</docs>
